module.exports = __webpack_public_path__ + "static/PFB_INTRO_IMAGES_04-3e4f7fd9a1b09f35026e48b73ced2f35.jpg";